import { render } from "./vweipagesadd.vue?vue&type=template&id=13fc43ea&scoped=true"
import script from "./vweipagesadd.vue?vue&type=script&lang=js"
export * from "./vweipagesadd.vue?vue&type=script&lang=js"

import "./vweipagesadd.vue?vue&type=style&index=0&id=13fc43ea&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fc43ea"]])

export default __exports__